<div class="detalles-container">
  <div class="header">
    <h2>{{ title }}</h2>
    <button irxBotonIcono tooltip="Cerrar" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="content">
    @if (data?.valores) {
      <div class="valores-section">
        <div class="info-grid">
          @if (data.valores.mensaje) {
            <div class="info-item full-width">
              <span class="label">Mensaje:</span>
              <pre class="value mensaje">{{ data.valores.mensaje }}</pre>
            </div>
          }
          @if (data.valores.protocolo) {
            <div class="info-item">
              <span class="label">Protocolo:</span>
              <span
                class="value protocol"
                [class.udp]="data.valores.protocolo === 'UDP'"
                [class.tcp]="data.valores.protocolo === 'TCP'"
              >
                &#x2B24; {{ data.valores.protocolo }}
              </span>
            </div>
          }
          @if (veces) {
            <div class="info-item">
              <span class="label">Recibida:</span>
              <span class="value">
                {{ veces }} veces en 30 s (las copias no se guardan)
              </span>
            </div>
          }
          @if (data.valores.origen) {
            <div class="info-item">
              <span class="label">Origen:</span>
              <span class="value">{{ data.valores.origen }}</span>
            </div>
          }
          @if (data.valores.puerto) {
            <div class="info-item">
              <span class="label">Puerto:</span>
              <span class="value">{{ data.valores.puerto }}</span>
            </div>
          }
          @if (data.valores.puertoLocal) {
            <div class="info-item">
              <span class="label">Puerto del servidor:</span>
              <span class="value">{{ data.valores.puertoLocal }}</span>
            </div>
          }
          @if (data.valores.idUnico) {
            <div class="info-item">
              <span class="label">Id del dispositivo:</span>
              <span class="value">{{ data.valores.idUnico }}</span>
            </div>
          }
          @if (data.valores.direccion) {
            <div class="info-item">
              <span class="label">Dirección:</span>
              <span class="value">{{ data.valores.direccion }}</span>
            </div>
          }
          @if (data.valores.codigo) {
            <div class="info-item">
              <span class="label">Código:</span>
              <span class="value">{{ data.valores.codigo }}</span>
            </div>
          }
          @if (data.valores.parseo) {
            <div class="info-item">
              <span class="label">Parseo:</span>
              <span
                class="value parseo"
                [class.ok]="data.valores.parseo === 'OK'"
                [class.sin-configurar]="
                  data.valores.parseo === 'No configurado'
                "
                [class.error]="data.valores.parseo === 'Error'"
              >
                &#x2B24; {{ data.valores.parseo }}
              </span>
            </div>
          }
          <!-- El hex va último y a lo ancho: es lo más largo, y para los
               protocolos binarios es lo único legible. -->
          @if (data.valores.hex) {
            <div class="info-item full-width">
              <span class="label">HEX:</span>
              <pre class="value mensaje">{{ data.valores.hex }}</pre>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
